import React from "react";
import "./App.css";
import Header from "./Header/Header";
import MainContent from "./MainContent/MainContent";
function App() {

  return (
    <div className="app-container">
      <Header />
      <MainContent />
    </div>
  );
}

export default App;
